import React from 'react';

const SvgAlert = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm-.005 14a1.696 1.696 0 10.002 3.392A1.696 1.696 0 0011.995 16zm0-11.5c-.936 0-1.695.691-1.695 1.543 0 .046.01.087.014.13h-.009l.677 7.477h.005c.044.474.477.85 1.008.85.533 0 .966-.375 1.01-.85h.005l.676-7.476h-.009c.005-.044.014-.085.014-.13 0-.853-.76-1.544-1.696-1.544z",
  fillRule: "evenodd"
}));

export default SvgAlert;